import { get, put } from "../utils/request";

export const getApiDocs = (serviceId) => {
  return get(`/v1/service-entries/${serviceId}/api-docs`);
}

export const getApiDocDetail = (apiId) => {
  return get(`/v1/api-docs/${apiId}`);
}

export const updatePrivacyApiDocs = (apiId, body) => {
  return put(`/v1/api-docs/${apiId}/update-privacy`, body);
}